<template>
  <div class="flex flex-col place-content-center">
    <div class="flex flex-col gap-2">
      <h2 class="text-5xl font-bold leading-[3.5rem] tracking-[-0.04rem] text-neutral-800">
        {{ t('auth.new_password.title') }}
      </h2>
      <p class="text-[1.125rem] font-semibold leading-[1.4375rem] tracking-[-0.02rem] text-neutral-500">
        {{ t('auth.new_password.under_title') }}
      </p>
    </div>

    <form class="mt-12 flex w-[29.625rem] flex-col place-content-center gap-2" @submit.prevent="onSubmit">
      <infuse-field :label="t('auth.common.password')">
        <infuse-input
          v-model="form.password"
          type="password"
          :placeholder="t('auth.common.password')"
          :tabindex="1"
          required
          autofocus
        />
      </infuse-field>

      <infuse-field :label="t('auth.common.confirm_password')">
        <infuse-input
          v-model="form.confirmPassword"
          type="password"
          :placeholder="t('auth.common.confirm_password')"
          :tabindex="2"
          required
        />
      </infuse-field>

      <div v-if="submitted && !passwordsMatch" class="text-sm text-red-500">
        {{ t('auth.common.passwords_dont_match') }}
      </div>

      <div class="flex items-center justify-end gap-4">
        <a @click="onBack">
          <label class="cursor-pointer text-xs font-bold leading-4 text-secondary-500">
            {{ t('auth.new_password.back_button') }}
          </label>
        </a>

        <infuse-button size="large" :loading="loading" type="submit" :tabindex="3">
          {{ t('auth.new_password.submit') }}
        </infuse-button>
      </div>
    </form>
  </div>
</template>

<script lang="ts" setup>
import { InfuseButton, InfuseField, InfuseInput } from '@infuse/ui/components';
import { reactive, computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

interface Props {
  loading?: boolean;
}

interface Emits {
  (e: 'submit', form: { password: string }): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

const router = useRouter();
const { t } = useI18n();

const form = reactive({
  password: '',
  confirmPassword: ''
});

const submitted = ref(false);
const passwordsMatch = computed(() => form.password === form.confirmPassword);

function onSubmit() {
  submitted.value = true;
  if (!passwordsMatch.value) return;
  emit('submit', { password: form.password });
}

function onBack() {
  window.location.reload();
}
</script>
